import React from 'react'

import { Currency, CurrencyAmount, Fraction, Percent } from '../../../sdk'
import { Button } from '@/ui/button'
import CurrencyLogo from '../../../components/CurrencyLogo'
import { Field } from '../../../state/mint/actions'

export function ConfirmAddModalBottom({
  noLiquidity,
  price,
  currencies,
  parsedAmounts,
  poolTokenPercentage,
  onAdd
}: {
  noLiquidity?: boolean
  price?: Fraction
  currencies: { [field in Field]?: Currency }
  parsedAmounts: { [field in Field]?: CurrencyAmount }
  poolTokenPercentage?: Percent
  onAdd: () => void
}) {
  return (
    <>
      <div className="flex justify-between py-1 text-sm">
        <span>{currencies[Field.CURRENCY_A]?.symbol} Deposited</span>
        <span className="flex items-center gap-2 font-mono tabular-nums">
          <CurrencyLogo currency={currencies[Field.CURRENCY_A]} size="16px" />
          {parsedAmounts[Field.CURRENCY_A]?.toSignificant(6)}
        </span>
      </div>
      <div className="flex justify-between py-1 text-sm">
        <span>{currencies[Field.CURRENCY_B]?.symbol} Deposited</span>
        <span className="flex items-center gap-2 font-mono tabular-nums">
          <CurrencyLogo currency={currencies[Field.CURRENCY_B]} size="16px" />
          {parsedAmounts[Field.CURRENCY_B]?.toSignificant(6)}
        </span>
      </div>
      <div className="flex justify-between py-1 text-sm">
        <span>Rates</span>
        <span className="font-mono tabular-nums">
          {`1 ${currencies[Field.CURRENCY_A]?.symbol} = ${price?.toSignificant(4)} ${currencies[Field.CURRENCY_B]?.symbol}`}
        </span>
      </div>
      <div className="flex justify-between py-1 text-sm">
        <span>Share of Pool:</span>
        <span className="font-mono tabular-nums">{noLiquidity ? '100' : poolTokenPercentage?.toSignificant(4)}%</span>
      </div>
      <div className="pt-3">
        <Button onClick={onAdd} className="w-full">
          {noLiquidity ? 'Create Pool & Supply' : 'Confirm Supply'}
        </Button>
      </div>
      <p className="text-[10px] text-muted-foreground italic mt-2">
        Output is estimated. If the price changes by more than 0.5% your transaction will revert.
      </p>
    </>
  )
}
